import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
    name: "safeHtml",
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(protected sanitizer: DomSanitizer) {}

    public transform(value?: string): SafeHtml {
        if (!value) {
            return "";
        }
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
